module.exports = __webpack_public_path__ + "static/media/Group 157.bf82f5ed.jpg";